import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { checkPermission } from "../../app/utils/helpers";
import { NumberInput } from "../../components/inputs/NumberInput";
import { SelectInput } from "../../components/inputs/Select";
import { ThemeButton } from "../../components/buttons/ThemeButton";
import { config } from "../../app/utils/config.js";
import {
  getSettings,
  setLocalSettings,
  updateSettings,
  setSelectedCountry,
  setLanguage
} from "./settingsSlice";
import styles from "./Settings.module.css";
import SettingsPanelHeader from "../../components/settings/SettingsPanelHeader";

export default function GeneralSettingsTab() {

  const dispatch = useDispatch()

  const settings = useSelector((state) => state.settings)
  const localSettingsList = useSelector(
    (state) => state.settings.localSettingsList
  )

  const [lang, setLang] = useState(settings.lang)

  const languages = [
    { value: "en", label: "English" },
    { value: "fr", label: "Français" },
  ]

  const handleLanguageChange = (selectedOption) => {
    setLang(selectedOption.value)
    dispatch(setLanguage(selectedOption.value))
  }

  const handleParameterChange = (event) => {
    let changedParam = {
      value: event.target.value,
      id: event.target.id
    }
    dispatch(setLocalSettings(changedParam))
  }

  function handleSaveLocalSettings() {
    dispatch(updateSettings({
      fields: Object.values(localSettingsList).map(s => {
        console.log(s)
        let id = s.value
        let value = s.settingValue
        switch (s.type) {
          case "string":
            value = String(s.settingValue)
            break
          case "number":
            value = Number(s.settingValue)
            break
          default:
            break
        }
        return {
          id: id,
          value: value
        }
      }),
      id_country: settings.selectedCountry && settings.selectedCountry.value
    })).then(() => dispatch(getSettings()))
  }

  const handleCountryChange = (option) => {
    dispatch(setSelectedCountry(option))
  }

  let isEdit = checkPermission(config.scopes.settings, config.permissionTypes.edit)

  return (
    <div>
      <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          <div className={styles.menuContent}>
            <SettingsPanelHeader
              icon="pi-user"
              title={<Langs str="User settings" />}
              description={<Langs str="SETTINGS_USER_DESC" />}
            />
            <div className={styles.panelBody}>
              <div className={styles.settingRow}>
                <div className={styles.settingRowText}>
                  <label className={styles.settingLabel} htmlFor="lang_selector">
                    <Langs str="LANGUAGE" />
                  </label>
                  <span className={styles.settingHint}>
                    <Langs str="SETTINGS_LANGUAGE_HINT" />
                  </span>
                </div>
                <div className={styles.settingRowControl}>
                  <SelectInput
                    key={"lang_selector"}
                    value={lang}
                    onChange={handleLanguageChange}
                    options={languages} />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {isEdit && Object.values(localSettingsList).length > 0 && <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          <div className={styles.menuContent}>
            <SettingsPanelHeader
              icon="pi-globe"
              title={<Langs str="Global settings" />}
              description={<Langs str="SETTINGS_GLOBAL_DESC" />}
              actions={
                <>
                  <label className="fw-bold mb-0 me-2" style={{ fontSize: 13 }}>
                    <Langs str="country" />
                  </label>
                  <div className={styles.filterField}>
                    <SelectInput
                      value={settings.selectedCountry && settings.selectedCountry.value}
                      onChange={handleCountryChange}
                      options={[{
                        value: null,
                        label: "Default",
                      }, ...settings.countries]
                      }
                    />
                  </div>
                </>
              }
            />
            <div className={styles.panelBody}>
              {Object.values(localSettingsList).map((setting) => (
                <div className={styles.settingRow} key={`ITEM_${setting.id}`}>
                  <div className={styles.settingRowText}>
                    <label className={styles.settingLabel} htmlFor={String(setting.id)}>
                      <Langs str={setting.label} />
                    </label>
                  </div>
                  <div className={styles.settingRowControl}>
                    <NumberInput
                      name={setting.label}
                      min={setting.min || 0}
                      id={setting.id}
                      data-key={setting.value}
                      max={setting.max || 999}
                      onChange={handleParameterChange}
                      value={setting.settingValue}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.panelFooter}>
              <span className={styles.panelFooterHint}>
                <Langs str="SETTINGS_GLOBAL_SAVE_HINT" />
              </span>
              <div className={styles.panelFooterAction}>
                <ThemeButton
                  title="SAVE"
                  active={true}
                  onClick={() => handleSaveLocalSettings()}
                ></ThemeButton>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      }
    </div>
  )
}
